"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentSaver = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _Config = require("../Utility/Config");

var _ContentMapper = require("./ContentMapper");

var ContentSaver = /*#__PURE__*/function () {
  function ContentSaver(config, content, schema) {
    (0, _classCallCheck2["default"])(this, ContentSaver);
    (0, _defineProperty2["default"])(this, "api", void 0);
    this.api = new _sdk.ContentsApi((0, _Config.includeFlow)(config));
    this.config = config;
    this.schema = schema;
    this.content = content;
  }

  (0, _createClass2["default"])(ContentSaver, [{
    key: "saveAsync",
    value: function () {
      var _saveAsync = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(status, data) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!data) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return (0, _ContentMapper.mapFormBuilderResultToSchema)(this.config, data, this.schema);

              case 3:
                this.content.data = _context.sent;

              case 4:
                if (!(status === "Published" && !this.content.id && !this.content.scheduleJob)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return this.createPublishedAsync();

              case 7:
                return _context.abrupt("return", _context.sent);

              case 10:
                _context.next = 12;
                return this.saveContentItemAndChangeStatusAsync(status);

              case 12:
                return _context.abrupt("return", _context.sent);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveAsync(_x, _x2) {
        return _saveAsync.apply(this, arguments);
      }

      return saveAsync;
    }()
  }, {
    key: "saveContentItemAndChangeStatusAsync",
    value: function () {
      var _saveContentItemAndChangeStatusAsync = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(status) {
        var result, _this$content$schedul;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.content.id) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return this.api.putContent(this.config.appName, this.schema.name, this.content.id, this.content);

              case 3:
                result = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.next = 8;
                return this.api.postContent(this.config.appName, this.schema.name, this.content);

              case 8:
                result = _context2.sent;

              case 9:
                if (!(status && result.id)) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 12;
                return this.api.putContentStatus(this.config.appName, this.schema.name, result.id, {
                  status: status,
                  dueTime: (_this$content$schedul = this.content.scheduleJob) === null || _this$content$schedul === void 0 ? void 0 : _this$content$schedul.dueTime,
                  notificationDetails: this.content.notificationDetails
                });

              case 12:
                result = _context2.sent;

              case 13:
                return _context2.abrupt("return", result);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveContentItemAndChangeStatusAsync(_x3) {
        return _saveContentItemAndChangeStatusAsync.apply(this, arguments);
      }

      return saveContentItemAndChangeStatusAsync;
    }()
  }, {
    key: "createPublishedAsync",
    value: function () {
      var _createPublishedAsync = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var result, bulkResult, _bulkResult$, contentId, error;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.api.bulkContents(this.config.appName, this.schema.name, {
                  jobs: [{
                    data: this.content.data,
                    categories: this.content.categories,
                    tags: this.content.tags,
                    permissionSet: this.content.permissionSet,
                    notificationDetails: this.content.notificationDetails,
                    id: this.content.id,
                    type: _sdk.BulkUpdateType.Upsert
                  }],
                  doNotScript: false,
                  publish: true,
                  optimizeValidation: true
                });

              case 2:
                bulkResult = _context3.sent;
                _bulkResult$ = bulkResult[0], contentId = _bulkResult$.contentId, error = _bulkResult$.error;

                if (!error) {
                  _context3.next = 6;
                  break;
                }

                throw new Error(error.message);

              case 6:
                if (!contentId) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 9;
                return this.api.getContent(this.config.appName, this.schema.name, contentId);

              case 9:
                result = _context3.sent;
                _context3.next = 13;
                break;

              case 12:
                result = this.content;

              case 13:
                return _context3.abrupt("return", result);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createPublishedAsync() {
        return _createPublishedAsync.apply(this, arguments);
      }

      return createPublishedAsync;
    }()
  }]);
  return ContentSaver;
}();

exports.ContentSaver = ContentSaver;